import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-input-footer',
  templateUrl: './input-footer.component.html',
  styleUrls: ['./input-footer.component.scss']
})
export class InputFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
